(function () {
  if (window.__hpbVideoLifecycle) return;
  window.__hpbVideoLifecycle = true;

  var watched = [];
  var registered = new WeakSet();
  var noop = function () {};

  function isScrubVideo(video) {
    return video.dataset.hpbVideoMode === 'scrub' || video.classList.contains('hpb-video-scrub');
  }

  function shouldAutoplay(video) {
    return video.dataset.hpbVideoAutoplay !== 'false';
  }

  // Abort any in-flight fetch, zero out sources, remove autoplay
  function strip(video) {
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.querySelectorAll('source').forEach(function (s) {
      if (s.src && !s.dataset.hpbSrc) {
        s.dataset.hpbSrc = s.src;
        s.removeAttribute('src');
      }
    });
    video.load(); // aborts in-progress metadata fetch started by preload="metadata"
  }

  function activate(video) {
    var restored = false;
    video.querySelectorAll('source').forEach(function (s) {
      if (s.dataset.hpbSrc && !s.getAttribute('src')) {
        s.src = s.dataset.hpbSrc;
        restored = true;
      }
    });
    if (restored) video.load();
    if (isScrubVideo(video)) return;
    if (!shouldAutoplay(video)) return;
    video.play().catch(noop);
  }

  function deactivate(video) {
    video.pause();
    var hadSrc = false;
    video.querySelectorAll('source').forEach(function (s) {
      if (s.getAttribute('src')) {
        s.removeAttribute('src');
        hadSrc = true;
      }
    });
    if (hadSrc) video.load(); // free decoder buffers + abort network
  }

  // Returns false when the video should not play regardless of viewport position:
  //   1. ancestor is display:none  (non-active tab, wrong PC/MB breakpoint)
  //   2. inside a Swiper slide that is not the active one
  function isInActiveContext(video) {
    if (video.offsetParent === null) return false;
    var slide = video.closest && video.closest('.swiper-slide');
    if (slide && !slide.classList.contains('swiper-slide-active')) return false;
    return true;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && isInActiveContext(entry.target)) {
        activate(entry.target);
      } else {
        deactivate(entry.target);
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.01 });

  function register(video) {
    if (registered.has(video)) return;
    registered.add(video);
    watched.push(video);
    strip(video);
    io.observe(video);
  }

  function scan(root) {
    (root || document).querySelectorAll('video.hpb-lazy-video').forEach(register);
  }

  // Re-evaluate all videos when a class change alters active context
  // (e.g., .swiper-slide-active toggles, .is-active toggles on tabs)
  var pending = false;

  function reevaluateAll() {
    pending = false;
    // prune detached nodes
    watched = watched.filter(function (v) { return document.body.contains(v); });
    watched.forEach(function (video) {
      var rect = video.getBoundingClientRect();
      var margin = 200;
      var inViewport = rect.bottom > -margin && rect.top < window.innerHeight + margin;
      if (inViewport && isInActiveContext(video)) {
        activate(video);
      } else {
        deactivate(video);
      }
    });
  }

  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(reevaluateAll);
  }).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });

  // Pick up Swiper loop-cloned slides (and any future dynamic video inserts)
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('video.hpb-lazy-video')) {
          register(n);
        } else if (n.querySelectorAll) {
          n.querySelectorAll('video.hpb-lazy-video').forEach(register);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  function boot() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
